import styled from "styled-components";
import { Icon } from "@evergis/ui";

export const TableIconContainer = styled.div`
  position: relative;
  top: -0.06rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
`;

export const TableTitleContainer = styled.div`
  margin-left: 0.12rem;
`;

export const TableTitle = styled.div`
  position: relative;
  top: -0.08rem;
  color: ${({ theme }) => theme.palette.textPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TableSubtitle = styled.div`
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme }) => theme.palette.textDisabled};
  height: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TableInformation = styled.div<{ warning?: boolean }>`
  display: flex;
  align-items: baseline;
  margin-top: 1rem;

  ${TableIconContainer} {
    ${Icon} {
      &:after {
        color: ${({ warning }) => warning && "#FF6933"};
      }
    }
  }

  ${TableTitle} {
    color: ${({ warning }) => warning && "#FF6933"};
  }
`;
